import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PasswordSetupState } from "../../../Interfaces/ReduxSliceInterface";

const initialState: PasswordSetupState = {
  passwordSetupRequired: true,
  passwordSetupToken: "",
};

const passwordSetupSlice = createSlice({
  name: "passwordSetup",
  initialState,
  reducers: {
    setPasswordSetup: (
      state,
      action: PayloadAction<{
        passwordSetupRequired: boolean;
        passwordSetupToken: string;
      }>
    ) => {
      state.passwordSetupRequired = action.payload.passwordSetupRequired;
      state.passwordSetupToken = action.payload.passwordSetupToken;
    },
    clearPasswordSetup: (state) => {
      state.passwordSetupRequired = true;
      state.passwordSetupToken = "";
    },
  },
});

export const { setPasswordSetup, clearPasswordSetup } =
  passwordSetupSlice.actions;
export default passwordSetupSlice.reducer;

